var React = require('react');

function PanelBottom (props) {
    return React.createElement("svg",props,React.createElement("path",{"style":{"fillRule":"evenodd","clipRule":"evenodd","fill":"#FFC914"},"d":"M1440,0H0v166L624,11.7c63.1-15.6,128.9-15.6,192,0L1440,166V0z\n\t"}));
}

PanelBottom.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 1440 166","style":{"enableBackground":"new 0 0 1440 166"},"xmlSpace":"preserve"};

module.exports = PanelBottom;

PanelBottom.default = PanelBottom;
